// extracted by mini-css-extract-plugin
module.exports = {"blockInternal":"style_blockInternal__35UMd","descText":"style_descText__33zcD","input2FA":"style_input2FA__2dUqk"};